import React from 'react';

import * as types from '#constants/types';

interface ViewType {
    setShowBackButton: (show: boolean | undefined) => void;
    setAppBarTitle: (title: string | undefined) => void;
    setAppBarChildren: (children: React.ReactNode | undefined) => void;

    showBackButton?: boolean;
    appBarTitle?: string;
    appBarChildren?: React.ReactNode | undefined;

    userDetail?: types.UserDetail;
}

export default React.createContext<ViewType>({
    setShowBackButton: () => {},
    setAppBarTitle: () => {},
    setAppBarChildren: () => {},

    showBackButton: false,
    appBarTitle: undefined,
    appBarChildren: undefined,

    userDetail: undefined,
});
